import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class SpiderLegend extends Vue {

    @Prop({ default: true })
    private hasPositive!: boolean

    @Prop({ default: true })
    private hasNegative!: boolean

    @Prop({ default: true })
    private hasWinner!: boolean

    @Prop({ default: true })
    private hasPassive!: boolean
}
